import React, { useState, useEffect } from 'react';
import RightBannerAd from '../components/RightBannerAd';
import HomePhotoCarousel from '../components/HomePhotoCarousel';
import { apiService } from '../services/api';

function formatPublishDate(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
}

const Home: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [bodyText, setBodyText] = useState('');
  const [linkUrl, setLinkUrl] = useState('');
  const [linkLabel, setLinkLabel] = useState('');
  const [updatedAt, setUpdatedAt] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    let cancelled = false;
    apiService
      .getHomeAnnouncement()
      .then((data) => {
        if (!cancelled) {
          setBodyText(data.body_text || '');
          setLinkUrl(data.link_url || '');
          setLinkLabel(data.link_label || '');
          setUpdatedAt(data.updated_at);
          setLoaded(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setLoaded(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const showAnnouncement = loaded && bodyText.trim().length > 0;

  return (
    <div className="home-root">
      <div className="home-container">
        <div className="home-main-column" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 32, paddingTop: isMobile ? '48px' : '64px' }}>
          <HomePhotoCarousel />

          {showAnnouncement && (
            <div style={{ 
              textAlign: 'center', 
              marginBottom: '24px',
              padding: isMobile ? '0 16px' : '0'
            }}>
              <div className="home-announcement-box" style={{
                maxWidth: '600px',
                margin: '0 auto',
                backgroundColor: '#e3f2fd',
                padding: isMobile ? '32px 20px' : '40px',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                border: '2px solid #e2e8f0',
                textAlign: 'left'
              }}>
                <div className="home-announcement-header" style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '24px'
                }}>
                  <div className="icon" style={{
                    width: '48px',
                    height: '48px',
                    backgroundColor: '#3182ce',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '20px'
                  }}>
                    <span style={{ color: 'white', fontSize: '24px', fontWeight: 'bold' }}>📢</span>
                  </div>
                  <h3 style={{
                    fontSize: '24px',
                    color: '#2d3748',
                    margin: '0',
                    fontWeight: '600'
                  }}>
                    最新消息
                  </h3>
                </div>
                <p style={{
                  color: '#4a5568',
                  lineHeight: '1.8',
                  fontSize: '16px',
                  marginBottom: linkUrl && linkLabel ? '16px' : '24px',
                  paddingLeft: '4px',
                  whiteSpace: 'pre-wrap'
                }}>
                  {bodyText}
                </p>
                {linkUrl && linkLabel ? (
                  <p style={{
                    marginBottom: '24px',
                    paddingLeft: '4px'
                  }}>
                    <a
                      href={linkUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: '#3182ce',
                        fontWeight: '600',
                        fontSize: '16px',
                        textDecoration: 'underline'
                      }}
                    >
                      {linkLabel}
                    </a>
                  </p>
                ) : null}
                {updatedAt ? (
                  <div style={{
                    fontSize: '14px',
                    color: '#718096',
                    fontStyle: 'italic',
                    paddingLeft: '4px'
                  }}>
                    發布日期：{formatPublishDate(updatedAt)}
                  </div>
                ) : null}
              </div>
            </div>
          )}
          
          {/* Banner Ad Below Announcement */}
          <div className="home-banner-below" style={{ 
            width: '100%', 
            maxWidth: '600px', 
            display: 'flex', 
            justifyContent: 'center',
            marginTop: '24px'
          }}>
            <RightBannerAd />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
